<section
  class="parent-learn-quiz"
  role="region"
  [attr.aria-label]="'app.parentLearning.quiz.title' | translate"
  tabindex="-1"
>
  <header class="parent-learn-quiz__header">
    <h3 class="parent-learn-quiz__title">
      {{ 'app.parentLearning.quiz.title' | translate }}
    </h3>
    <p class="parent-learn-quiz__hint">
      @if (reviewMode()) {
        {{ 'app.parentLearning.quiz.reviewHint' | translate }}
      } @else {
        {{ 'app.parentLearning.quiz.hint' | translate }}
      }
    </p>
  </header>
  <app-quiz
    [quizId]="quizId()"
    [taskId]="reviewMode() ? null : taskId()"
    [description]="description()"
    (quizCompleted)="completed.emit($event)"
    (answerIncorrect)="answerIncorrect.emit()"
  />
</section>
